// These flags only modify a sales form; they do not grant console access.
const ESAVE_ONLY_CAPABILITIES = new Set([
    'gestion_facturas', 'admin_esave', 'no_mandar_firma', 'no_credit_check', 'C2', 'A3',
]);

export function isESaveOnly(permissions) {
    const capabilities = permissions?.capabilities;
    return Array.isArray(capabilities) && capabilities.includes('gestion_facturas')
        && capabilities.every(capability => ESAVE_ONLY_CAPABILITIES.has(capability));
}

export function openESave(location = window.location) {
    location.replace('/esave');
}
